import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/pt-br';

dayjs.extend(relativeTime);
dayjs.locale('pt-br');

export const formatTimeAgo = (dateStr) => {
  if (!dateStr) return '-';
  const date = dayjs(dateStr);
  const now = dayjs();
  const diffMinutes = now.diff(date, 'minute');
  const diffHours = now.diff(date, 'hour');
  const diffDays = now.diff(date, 'day');

  if (diffMinutes < 1) return 'Agora';
  if (diffMinutes < 60) return `${diffMinutes}min`;
  if (diffHours < 24) return `${diffHours}h`;
  if (diffDays < 30) return `${diffDays}d`;
  return date.format('DD/MM/YY');
};

/**
 * Retorna cor baseada no tempo offline - DIFERENTES para dark/light mode
 * @param {string} lastUpdate - Data do último update
 * @param {object} themeOrTokens - theme (legacy) ou tokens (premium)
 */
export const getOfflineColor = (lastUpdate, themeOrTokens) => {
  // Detecta se recebeu tokens premium ou theme legacy
  const isDark = themeOrTokens?.isDark ?? (themeOrTokens?.palette?.mode === 'dark') ?? true;

  const darkColors = {
    success: '#00d4aa',
    warning: '#d29922',
    error: '#f85149',
    muted: '#6e7681',
  };

  const lightColors = {
    success: '#00875a',
    warning: '#9a6700',
    error: '#cf222e',
    muted: '#656d76',
  };

  const colors = isDark ? darkColors : lightColors;

  if (!lastUpdate) return colors.muted;
  const diffHours = dayjs().diff(dayjs(lastUpdate), 'hour');
  if (diffHours < 1) return colors.success;
  if (diffHours < 24) return colors.warning;
  return colors.error;
};

/**
 * Retorna classe CSS baseada no tempo desde última atualização
 * Usa classes CSS definidas em lightModeOverrides.css para garantir
 * que as cores funcionem mesmo com !important CSS overrides
 * @param {string} lastUpdate - ISO date string
 * @returns {string} Nome da classe CSS (time-color-recent|warning|error|unknown)
 */
export const getOfflineColorClass = (lastUpdate) => {
  if (!lastUpdate) return 'time-color-unknown';

  const diffHours = dayjs().diff(dayjs(lastUpdate), 'hour');

  if (diffHours < 1) return 'time-color-recent';
  if (diffHours < 24) return 'time-color-warning';
  return 'time-color-error';
};
